import {
  slideInOut,
  ShrinkInOutAnimation,
} from './../../animations/animations';
import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import {
  GlobalSearchService,
  GlobalSearchResult,
} from './global-search.service';
import { Subject, of } from 'rxjs';
import { debounceTime, switchMap, catchError, finalize } from 'rxjs/operators';

export enum SearchViewModeEnum {
  results = 'results',
  preferences = 'preferences',
  welcome = 'welcome',
  none = 'none',
}
@Component({
  selector: 'app-global-search',
  templateUrl: './global-search.component.html',
  styleUrls: ['./global-search.component.css'],
  animations: [ShrinkInOutAnimation, slideInOut],
})
export class GlobalSearchComponent {
  @ViewChild('searchInput') searchInput: ElementRef;
  @ViewChild('interactiveBox') interactiveBox: ElementRef;
  @ViewChild('searchArea') searchArea: ElementRef;

  searchViewModeEnum = SearchViewModeEnum;
  searchViewMode: SearchViewModeEnum = SearchViewModeEnum.none;
  searchWord: string;
  isSearchInProgress: boolean = false;
  results: GlobalSearchResult = { contacts: [], products: [], actions: [] };

  private searchSubject = new Subject<string>();

  constructor(private globalSearchService: GlobalSearchService) {
    this.searchSubject
      .pipe(
        debounceTime(500),
        switchMap((query) => {
          if (!query || query.length === 0) {
            this.isSearchInProgress = false;
            this.searchViewMode = SearchViewModeEnum.welcome;
            return of(null);
          }
          this.isSearchInProgress = true;
          return this.globalSearchService.search(query).pipe(
            catchError((err) => {
              console.error('Search failed', err);
              return of(null);
            }),
            finalize(() => (this.isSearchInProgress = false))
          );
        })
      )
      .subscribe((res) => {
        this.isSearchInProgress = false;
        if (res) {
          this.results = res;
          this.searchViewMode = SearchViewModeEnum.results;
        } else {
          // handle empty or error
        }
      });
  }

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!this.searchArea.nativeElement.contains(event.target)) {
      this.terminateSearch();
    }
  }

  onSearchWordChange() {
    if (this.searchWord?.length) {
      this.isSearchInProgress = true; // Show spinner immediately
      this.searchSubject.next(this.searchWord);
    } else {
      this.isSearchInProgress = false;
      this.searchViewMode = SearchViewModeEnum.welcome;
    }
  }

  initSearch() {
    if (this.searchWord?.length) {
      this.searchViewMode = SearchViewModeEnum.results;
    } else {
      this.searchViewMode = SearchViewModeEnum.welcome;
    }
  }

  terminateSearch() {
    this.searchViewMode = SearchViewModeEnum.none;
  }

  resetSearch() {
    this.searchWord = null;
    this.searchViewMode = SearchViewModeEnum.welcome;
  }
}
